var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2176 4.28231C22.511 3.98896 22.511 3.51335 22.2176 3.22001C21.9243 2.92666 21.4487 2.92666 21.1554 3.22001L17.6477 6.72763C16.3006 6.09521 14.7847 5.69688 13.124 5.69688C7.5774 5.69688 3.61451 9.83875 2.22254 12.5279C1.94987 13.0547 1.91931 13.6727 2.1779 14.2065C2.80497 15.501 4.13745 17.1279 5.90796 18.4674L2.67688 21.6985C2.38353 21.9918 2.38353 22.4674 2.67688 22.7608C2.97022 23.0541 3.44583 23.0541 3.73917 22.7608L22.2176 4.28231ZM8.02222 16.3531L9.36572 15.0096C9.17331 14.5476 9.06707 14.0407 9.06707 13.509C9.06707 11.3518 10.8159 9.60301 12.9731 9.60301C13.5048 9.60301 14.0117 9.70925 14.4737 9.90166L15.8174 8.55796C14.98 8.07584 14.0088 7.80007 12.9731 7.80007C9.82024 7.80007 7.26432 10.356 7.26432 13.5089C7.26432 14.5445 7.5401 15.5157 8.02222 16.3531Z",
    fill: "#A8A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8235 21.0205C11.4148 21.0205 10.0576 20.6924 8.8056 20.161L10.3696 18.5908C11.1502 18.9915 12.0353 19.2177 12.9731 19.2177C16.126 19.2177 18.6819 16.6617 18.6819 13.5089C18.6819 12.5628 18.4518 11.6704 18.0444 10.8848L20.4164 8.50326C21.8755 9.71403 22.9913 11.1255 23.7039 12.3289C24.0853 12.973 24.1252 13.7606 23.7921 14.4309C22.4561 17.1192 19.0206 21.0205 12.8235 21.0205Z",
    fill: "#A8A8A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9731 17.415C12.5417 17.415 12.1267 17.3451 11.7388 17.216L16.6751 12.2597C16.8074 12.652 16.8791 13.0721 16.8791 13.509C16.8791 15.6663 15.1303 17.415 12.9731 17.415Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeclose);
export default __webpack_public_path__ + "static/media/eyeclose.a704333425c31c32a10c0973bee54c3f.svg";
export { ForwardRef as ReactComponent };